import Store from 'redux/store';
import {
  FETCH_CARD_BRANDS,
  FETCH_CARD_BRANDS_FAIL,
  FETCH_CARD_BRANDS_SUCCESS,
} from 'redux/Reducers/CardBrands/CardBrandsReducer';
import { cloudloyalty } from '../clients';

const FetchCardBrands = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_CARD_BRANDS });
  cloudloyalty(User).get('/v1/configurations/cardBrands').then((response) => {
    Store.dispatch({
      type: FETCH_CARD_BRANDS_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_CARD_BRANDS_FAIL,
      error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};
export default FetchCardBrands;
